// extracted by mini-css-extract-plugin
module.exports = {"image":"i_Fa"};